import { cof_settlement_date, cof_transaction_identifier, makeField, reference_id, vtSectionSelectors, vt_fields } from '@engine/features/virtual_terminal/vt_recurring_type';
import { exists } from '@engine/lib/utility/exists';

function attachDatePickers() {
  var $datetimepickers_date_month = $('.datetimepicker-date-month');

  if (exists($datetimepickers_date_month)) {
    $datetimepickers_date_month.datetimepicker({
      format: 'MMDD',
      locale: moment.locale(I18n.locale)
    });
  }
}

function showRequiredFields(terminal_sections) {
  $(terminal_sections).removeClass('hidden');
  vt_fields.forEach(function (field) {
    if (field.required) {
      makeField(field).required();
    } else {
      makeField(field).visible();
    }
  });
}

function listenForInputsChange(features) {
  var $cofIdentifierInput = makeField(cof_transaction_identifier).input;
  var $cofSettlementDateInput = makeField(cof_settlement_date).input;
  var $referenceIdInput = makeField(reference_id).input;
  var $recurringTypeInput = $('input[name*="recurring_type"]');

  function updateRequiredClasses() {
    if (exists($referenceIdInput) && exists($cofIdentifierInput) && exists($cofSettlementDateInput) && exists($recurringTypeInput)) {
      var referenceIdHasValue = $referenceIdInput.val().trim() !== '';
      var cofIdentifierHasValue = $cofIdentifierInput.val().trim() !== '';
      var cofSettlementDateHasValue = $cofSettlementDateInput.val().trim() !== '';
      var dropdownValue = $recurringTypeInput.val().trim();
      var terminal_sections = vtSectionSelectors(features);

      if (referenceIdHasValue) {
        makeField(reference_id).required();
        makeField(cof_transaction_identifier).optional();
        makeField(cof_settlement_date).optional();
        $(terminal_sections).addClass('hidden');
        vt_fields.forEach(function (field) {
          if (field.required) {
            makeField(field).optional();
          } else {
            makeField(field).hidden();
          }
        });
      } else if (cofIdentifierHasValue && cofSettlementDateHasValue) {
        var referenceIdField = makeField(reference_id);
        referenceIdField.visible();
        referenceIdField.optional();
        makeField(cof_transaction_identifier).required();
        makeField(cof_settlement_date).required();
        showRequiredFields(terminal_sections);
      } else if (dropdownValue === 'subsequent') {
        makeField(reference_id).required();
        makeField(cof_settlement_date).required();
        makeField(cof_transaction_identifier).required();
        showRequiredFields(terminal_sections);
      }
    }
  }

  $referenceIdInput.add($cofIdentifierInput).add($recurringTypeInput).on('input', updateRequiredClasses);
  $cofSettlementDateInput.on('dp.change', updateRequiredClasses);
  updateRequiredClasses();
}

var NonReferencedRecurring = {
  listenForInputsChange: listenForInputsChange,
  attachDatePickers: attachDatePickers
};
export default NonReferencedRecurring;